import { Dispatch, MouseEventHandler, SetStateAction, useEffect, useState } from "react";
import { mfaButtonEngagement } from "../../common/analytics";
import translate from "../../common/functions/translate";
import { SecurityCodeMethod } from "../hooks/useMfaApi";

interface GetAnotherCodeProps {
    type: SecurityCodeMethod
    onClick: MouseEventHandler<HTMLButtonElement>
    setShowInfoAlert: Dispatch<SetStateAction<boolean>>
    mfaAnalyticsHeading: string
}
export const GetAnotherCode = (props: GetAnotherCodeProps) => {
    const { onClick, setShowInfoAlert } = props;
    const counterStart = 60;
    const [counter, setCounter] = useState(counterStart);

    useEffect(() => {
        if (counter === 0) {
            setShowInfoAlert(false);
            return;
        }
        const timeout = setTimeout(() => {
            setCounter(prevCounter => prevCounter - 1);
        }, 1000);
        return () => {
            clearTimeout(timeout);
        }
    }, [counter, setCounter, setShowInfoAlert]);

    const secondOrSeconds = counter === 1 ? translate('second') : translate("seconds");

    const getNewCode = <>
        <span className="ds-u-font-weight--semibold">
            {translate(`did_not_get_code`)}
        </span>{" "}
        <button
            type="button"
            className="ds-c-button ds-c-button--ghost ds-u-padding--0"
            onClick={(event) => {
                event.preventDefault();
                mfaButtonEngagement({
                    text: translate('get_another_code'),
                    buttonStyle: 'transparent',
                    buttonType: 'button',
                    parentComponentHeading: props.mfaAnalyticsHeading,
                    siteSection: 'mfa'
                });
                onClick(event);
                setCounter(counterStart);
            }}
        >
            {translate("get_another_code")}
        </button>
    </>;

    const countdownTimer = <span>
        {translate("get_another_code_in")}{" "}
        <span className="ds-u-font-weight--bold">
            {counter} {secondOrSeconds}
        </span>
    </span>;

    // screen reader: announce timer every 10 seconds
    let ariaLive: React.AriaAttributes['aria-live'] = 'polite';
    if (counter < 60) {
        ariaLive = counter % 10 === 0 ? 'assertive' : 'off';
    }

    return <div className="ds-u-margin-bottom--3" role="timer" aria-atomic="true" aria-live={ariaLive}>
        {counter === 0 ? getNewCode : countdownTimer}
    </div>
}